import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { movies, categories } from '@/mocks/movies';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      const found = movies.find(
        (m) => m.title.includes(searchQuery.trim())
      );
      if (found) {
        navigate(`/article/${found.slug}`);
      }
    }
  };

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vintage%20cinema%20theater%20interior%20with%20warm%20red%20velvet%20curtains%20and%20golden%20stage%20lights%2C%20classic%20film%20projector%20beam%20cutting%20through%20darkness%2C%20nostalgic%201980s%20movie%20palace%20aesthetic%2C%20rich%20amber%20and%20crimson%20tones%2C%20atmospheric%20cinematic%20lighting%2C%20dramatic%20shadows&width=1920&height=1080&seq=hero-bg-80s-movie&orientation=landscape"
          alt="80s电影网 - 高清在线看免费不卡"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 font-bold mb-4 leading-tight">
          高清在线看<span className="text-primary-400">免费不卡</span>
        </h1>
        <p className="text-base md:text-lg text-background-200/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          蓝光画质搭配极速播引擎，点开即播不缓冲。涵盖电影、电视剧、动漫、综艺全集免费在线观看，每日更新热门影片。
        </p>

        <form onSubmit={handleSearch} className="flex items-center max-w-xl mx-auto mb-10">
          <div className="relative flex-1">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-search-line text-foreground-400 text-lg"></i>
              </div>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="搜索你想看的电影、电视剧..."
              className="w-full h-12 pl-11 pr-4 bg-background-50/95 text-foreground-950 text-sm rounded-l-full outline-none"
            />
          </div>
          <button
            type="submit"
            className="h-12 px-6 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-r-full transition-colors cursor-pointer whitespace-nowrap"
          >
            搜索
          </button>
        </form>

        <div className="flex flex-wrap items-center justify-center gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-2 px-5 py-2.5 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 text-sm font-medium rounded-full border border-background-50/20 transition-all cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={cat.icon}></i>
              </div>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}